export type GlideFit = 'contain' | 'fill' | 'max' | 'stretch' | 'crop' | string;

export interface GlideImageArgs {
  w?: number;
  h?: number;
  fit?: GlideFit;
  [key: string]: string | number | undefined;
}

type GlideSrc = string | URL | { url?: string; src?: string } | null | undefined;

function normalizeSrc(input: GlideSrc): string | null {
  if (!input) return null;

  if (typeof input === 'string') {
    const trimmed = input.trim();
    return trimmed.length ? trimmed : null;
  }

  if (input instanceof URL) return input.toString();

  if (typeof input === 'object') {
    if (typeof input.url === 'string' && input.url) return input.url;
    if (typeof input.src === 'string' && input.src) return input.src;
  }

  return null;
}

export default function glideImage(src: GlideSrc, args: GlideImageArgs = {}): string {
  const normalized = normalizeSrc(src);

  if (!normalized) return '';
  if (!normalized.includes('/img/')) {
    return normalized;
  }

  const urlAndRest = normalized.split('#');
  const [urlWithoutHash, hash = ''] = [urlAndRest[0], urlAndRest.slice(1).join('#')];
  const [pathOnly, query = ''] = urlWithoutHash.split('?');

  const dotIndex = pathOnly.lastIndexOf('.');
  if (dotIndex === -1) {
    return normalized;
  }

  const base = pathOnly.slice(0, dotIndex);
  const ext = pathOnly.slice(dotIndex + 1);

  let result = base;

  Object.entries(args).forEach(([key, value]) => {
    if (value !== undefined) {
      result += `-${key}_${value}`;
    }
  });

  result += `.${ext}`;

  const withQuery = query ? `${result}?${query}` : result;
  const withHash = hash ? `${withQuery}#${hash}` : withQuery;

  return withHash;
}
